export const lockTypeConfig = {
  heading: "Cerraduras y acceso",
  subtitle:
    "¿Cómo entra el huésped a tu alojamiento? Añade una o varias cerraduras (portal, unidad…), cada una con su nombre y tipo de acceso.",
  loading: "Cargando configuración…",

  enable: {
    title: "Enviar códigos de acceso",
    sub:
      "Si lo desactivas no enviaremos claves de acceso al huésped. Las instrucciones de llegada seguirán enviándose independientemente a esta configuración.",
  },

  scope: {
    labelRoom: "Habitación a configurar",
    labelUnit: "Unidad a configurar",
    hintRoom: "Cada habitación guarda su propia configuración de acceso.",
    hintUnit: "Cada unidad guarda su propia configuración de acceso.",
  },

  conflict: {
    title: "Estos espacios no usarán esta configuración",
    textBefore:
      "Guardan claves propias, y al enviarlas manda siempre la configuración más concreta.",
    textStrong: "Lo que edites aquí no les llegará",
    textAfter: "mientras sigan así:",
    lockCount: "cerradura | cerraduras",
    applying: "Aplicando…",
    applyAll: "Aplicar esta configuración a todos",
  },

  lockBadge: "Cerradura {n}",
  removeLock: "Quitar cerradura",
  nameLabel: "Nombre de la entrada",
  namePlaceholder: "O escribe un nombre…",
  typeLabel: "Tipo de acceso",
  codePlaceholderBox: "Código del cajetín · Ej. 5817",
  codePlaceholderLock: "Código de la cerradura · Ej. 5817",
  lockFallback: "Cerradura",
  connectedSuffix: "conectada",
  editConfig: "Editar configuración",
  configure: "Configurar…",
  addLock: "Añadir otra cerradura",
  roomsHint:
    "Cada habitación física tiene su propia cerradura y código. Configúralas aquí, una por una.",

  wa: {
    online: "en línea",
    today: "Hoy",
    captionOverriding: "Así lo recibe {source} · no los espacios avisados arriba",
    captionPreview: "Vista previa · así lo recibirá el huésped de {source}",
  },

  modal: {
    title: "Configura tu cerradura inteligente",
    sub: "Elige tu marca y conéctala para generar claves automáticas por reserva.",
    close: "Cerrar",
    note: "Añade primero una unidad al anuncio para configurar la cerradura inteligente.",
  },

  providerOther: "Otra marca",

  presets: {
    main: "Entrada principal",
    property: "Entrada del alojamiento",
    unit: "Entrada de la unidad",
  },

  entryFallback: "Entrada",
  roomFallback: "Habitación",
  yourProperty: "tu alojamiento",

  types: {
    none: {
      title: "Cajetín con llaves",
      desc: "Una caja de seguridad con las llaves del alojamiento.",
    },
    dynamic: {
      title: "Cerradura Inteligente",
      desc: "Clave nueva automática por reserva.",
    },
    static: {
      title: "Cerradura con código estático",
      desc: "Código que se cambia de manera periódica de forma manual.",
    },
  },

  source: {
    room: "esta habitación",
    unit: "este alojamiento",
    property: "el anuncio",
  },

  preview: {
    boxText:
      "🔑 *{label} · {name}*\n\nEl cajetín de llaves se abre con el código: *{code}*\n\nDentro encontrarás las llaves del alojamiento. Por favor, déjalas de nuevo al salir.",
    dynamicText:
      "🔒🔑 *{label} · {name}*\n\nTu código de acceso es: *58117*\n\nVálido durante tu estancia.",
    staticText:
      "🔒🔑 *{label} · {name}*\n\nEl código de la cerradura es: *{code}*\n\nÚsalo para abrir la puerta del alojamiento.",
  },

  summary: {
    dynamic: "Cerradura inteligente",
    codePrefix: "Código {code}",
    staticCode: "Código fijo",
    boxPrefix: "Cajetín {code}",
    empty: "Sin configurar",
  },

  toast: {
    saved: "Acceso guardado",
    saveError: "No se pudo guardar el método de acceso.",
    unified: "Configuración unificada",
    unifyError: "No se pudo unificar la configuración.",
    savedRoom: "Acceso guardado · {room}",
    saveErrorRoom: "No se pudo guardar el acceso de {room}.",
    theRoom: "la habitación",
  },
};
